import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref, toRef } from 'vue'
import { useJobFollowersPicker } from '@/components/tickets/JobFollowersPicker/JobFollowersPicker'
import {
  HeadlessAutoCompleteValueType,
  ValueResolver,
} from '@/components/vision/next/inputs/useAutoComplete'
import User from '@/models/user'
import { useStore } from 'vuex-composition-helpers'
import PickerListVirtualized from '@/components/vision/next/picker-list/PickerListVirtualized.vue'
import PickerListItem from '@/components/vision/next/picker-list/PickerListItem.vue'
import AutoCompleteShell from '@/components/vision/next/inputs/AutoCompleteShell.vue'
import VsText from '@/components/vision/VsText.vue'
import { useFormField } from '@/components/vision/next/forms/useFormAdapter'
import { PickerItemType } from '@/components/vision/next/picker-list/models'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobFollowersPicker',
  props: {
    followerSids: null,
    isDisabled: { type: Boolean },
    jobHubId: null
  },
  emits: ["selected"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'selected', id: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  followerSids: string[]
  isDisabled: boolean
  jobHubId: string
}




const store = useStore()
const getUserBySid = computed<(id: string | null) => User | null | undefined>(
  () => store.getters['users/getBySid']
)

const followerSidsAsRef = toRef(props, 'followerSids')
const jobHubIdAsRef = toRef(props, 'jobHubId')
const autocomplete = ref()
const virtualizedList = ref()
const onNavigate = () => {
  autocomplete.value?.input?.focus()
}

const scrollToPosition = (pos: number) => {
  virtualizedList?.value?.scrollToPosition(pos)
}

const onValueChanged = (items: HeadlessAutoCompleteValueType[]) => {
  emit('selected', items?.map((i) => i.id as string) ?? [])
}

const isSelected = (item: HeadlessAutoCompleteValueType) => {
  return followerSidsAsRef.value.includes(item.id as string)
}

const valueResolver = async (id: string | null) => {
  const user = getUserBySid.value(id)
  if (user) return { id: user.id, title: user.name }
  return { id: null, title: null }
}

const onClose = () => {
  nextTick().then(() => runValidation())
}

const { allErrorMessages: remoteErrors, runValidation } = useFormField({
  value: followerSidsAsRef,
  required: false,
})

const customSelectItem = (arg: PickerItemType) => {
  autocomplete.value.input.focus()
  selectItem(arg)
  clearSearch()
}

const {
  items,
  updateSearch,
  selectItem,
  clear,
  clearSearch,
  noResultsMessage,
} = useJobFollowersPicker({
  onNavigate,
  scrollToPosition,
  valueResolver: valueResolver as ValueResolver,
  onValueChanged,
  value: followerSidsAsRef,
  jobHubId: jobHubIdAsRef,
})

return { __sfc: true,props, emit, store, getUserBySid, followerSidsAsRef, jobHubIdAsRef, autocomplete, virtualizedList, onNavigate, scrollToPosition, onValueChanged, isSelected, valueResolver, onClose, remoteErrors, runValidation, customSelectItem, items, updateSearch, selectItem, clear, clearSearch, noResultsMessage, PickerListVirtualized, PickerListItem, AutoCompleteShell, VsText }
}

})